var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.847,
    height: 26.086,
    viewBox: "0 0 30.847 26.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35583",
    d: "M149.831,554.6h3.4a.117.117,0,0,1,.121.116v1.818l-.121.137h-3.4l-.121-.137v-1.818a.117.117,0,0,1,.121-.116Zm24.533-19.042a1.441,1.441,0,0,0-.977-.367H156.87a1.427,1.427,0,0,0-.968.367l9.232,7.876Zm-18.829.851v11.514l6.681-5.69Zm12.632,5.824,6.681,5.69V536.408Zm-3.033,2.671-2.429-2.186-6.8,5.941a2.426,2.426,0,0,0,.968.367h16.517a2.439,2.439,0,0,0,.977-.367l-6.8-5.941Zm-7.775-13.837H145.7a1.767,1.767,0,0,0-1.7,1.821v22.447a1.765,1.765,0,0,0,1.7,1.818h11.66a1.869,1.869,0,0,0,1.824-1.818v-5.593h-1.335v4.122H145.216v-20.01h12.632v.62h1.335v-1.586a1.871,1.871,0,0,0-1.824-1.821Z",
    transform: "translate(-144.001 -531.066)",
    fill: "#a2adbf",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite_icon.b4f0ce3f54ab5d70f3b6f12f3cec965d.svg";
export { ForwardRef as ReactComponent };